import { L10n } from '@flippingbook/web.react-kit/dist/L10n';
import { Link as KitLink } from '@flippingbook/web.react-kit/dist/Link';

import { loc } from '@/localization';
import { discoveryService } from '@/services/instance/discovery';

const siteUrl = discoveryService.get('site');

const EULA = `${siteUrl}help/publisher-2/licensing/flippingbook-publisher-end-user-license-agreement`;
const TOS = `${siteUrl}help/online/account-and-billing/flippingbook-online-terms-of-service`;
const PRIVACY_POLICY = `${siteUrl}help/common/privacy-policy-and-disclaimer`;

export function Policies({ isFBOnline, isPublisher2 }: { isFBOnline: boolean; isPublisher2: boolean }) {
    return (
        <>
            {isPublisher2 && (
                <KitLink
                    href={EULA}
                    target="_blank"
                >
                    {loc.Login.EULA}
                </KitLink>
            )}
            {isFBOnline && (
                <KitLink
                    href={TOS}
                    target="_blank"
                >
                    {loc.Login.Terms}
                </KitLink>
            )}
            {(isPublisher2 || isFBOnline) && <> {loc.Login.And} </>}
            <KitLink
                href={PRIVACY_POLICY}
                target="_blank"
            >
                <L10n
                    text={loc.Login.PrivacyPolicy}
                    replaces={[[' ', <>&nbsp;</>]]}
                />
            </KitLink>
        </>
    );
}
